import groupApptByDay from 'utils/group-appts-by-day.js';
import groupByApptStatus from 'utils/group-by-appt-status.js';

/**
 * @name ScheduleUpdateController
 * @description Controller for schedule updating
 * @param {type} $uibModalInstance Description
 * @param {type} $q Description
 * @param {type} Schedule Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Artists Description
 * @param {type} ShopHours Description
 * @param {type} Appointments Description
 * @param {type} artist Description
 * @param {type} schedule Description
 * @param {type} date Description
 * @param {type} moment Description
 * @param {type} ProcessSchedule Description
 * @param {type} ScheduleApiFormat Description
 * @param {type} ExceptionApiFormat Description
 * @param {type} CheckHoursCollisions Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function ScheduleUpdateController(
  $uibModalInstance,
  $q,
  Schedule,
  ScheduleUtilFactory,
  Artists,
  ShopHours,
  Appointments,
  artist,
  schedule,
  date,
  moment,
  ProcessSchedule,
  ScheduleApiFormat,
  ExceptionApiFormat,
  CheckHoursCollisions,
  Session,
  _
) {
  let vm = this;
  vm.isFuture = isFuture;
  vm.schedule = schedule;
  vm.artist = artist;
  vm.day = moment(date);
  vm.loading = false;
  const today = moment();

  // Public methods
  vm.submitException = submitException;
  vm.removeException = removeException;
  vm.editException = editException;
  vm.removeRule = removeRule;
  vm.edit = edit;

  let unsorted_artist_hours = [];
  let unsorted_selected_hours = [];

  vm.artist_schedule = {by_rules: [], by_exceptions: []};
  vm.selected_hours = {by_rules: [], by_exceptions: []};
  vm.artists = [];
  vm.appointments = [];
  vm.status = {};

  vm.shop_hours = ShopHours.shopHours;

  // For the Day Selector Plugin
  vm.weekdays = ScheduleUtilFactory.daysArray;

  // Swap text depending on Method of Creation
  vm.title_text = vm.artist ? 'Update schedule' : 'Add schedule';

  // Default Values for Form Fields.
  let temp = {
    raw_start_time: moment(vm.shop_hours[0].start_time, 'HH:mm:ss'), // Not ideal using [0] works for now.
    raw_end_time: moment(vm.shop_hours[0].end_time, 'HH:mm:ss'), // Not ideal using [0] works for now.
    raw_start_date: moment().toDate(),
    raw_end_date: moment().add(1, 'days').toDate()
  };

  vm.new_exception = {temp: _.cloneDeep(temp)};
  vm.new_schedule = {temp: _.cloneDeep(temp)};
  delete vm.new_schedule.temp.raw_end_date;

  let search = false;
  let timestamp;
  if (vm.artist) {
    Appointments.get(
      search,
      moment().startOf('day'),
      moment('2200-12-31'),
      timestamp,
      vm.artist.id
    )
    .then(function(appointments) {
      if (appointments.length > 0) {
        // Generate the Appointment Rules
        let statusGroups = groupByApptStatus(appointments);
        let dayGroups;
        if (!_.isUndefined(statusGroups.confirmed)) {
          dayGroups = groupApptByDay(statusGroups.confirmed);
        }
        vm.appointments = appointments;
        vm.appointmentDayGroups = dayGroups;
      } else {
        vm.appointmentDayGroups = groupApptByDay(vm.appointments);
      }
    });
  } else {
    Appointments.get(
      search,
      moment().startOf('day'),
      moment('2200-12-31'),
      timestamp
    )
    .then(function(appointments) {
      vm.appointments = appointments;
    });
  }

  // Artist Check
  if (vm.artist) {
    vm.status.adding = false;
    get_schedule();
  } else {
    vm.status.adding = true;
    Artists.fetchArtists().then(function(response) {
      let artists = response.confirmed;
      _.each(vm.schedule, function(schedule_data) {
        _.each(artists, function(tempArtist) {
          if (tempArtist && tempArtist.id === schedule_data.artist.id) {
            artists.splice(artists.indexOf(tempArtist), 1);
          }
        });
      });
      vm.artists = artists;
    });
  }

  // Select an Artist (When Adding to Schedule).
  vm.select_artist = function(artist) {
    vm.artist = (vm.artist && vm.artist.id === artist.id ? {} : artist);
    get_schedule();
  };

  // Detect Hour Collisions
  vm.detect_hours_collision = function(form_data) {
    CheckHoursCollisions.check(form_data, vm.appointments, vm.artist, vm.day.format('YYYY/MM/DD')).then(function(data) {
      form_data.collision_errors = [];
      form_data.collision_warnings = data.warnings;
    }, function(data) {
      form_data.collision_errors = data.errors;
      form_data.collision_warnings = data.warnings;
    });
  };

  // Check Form Dates
  vm.check_dates = function(form_data, override) {
    form_data.date_errors = Schedule.check_dates(form_data, override, vm.day);
  };

  // Submit the Schedule
  vm.submit_schedule = function(form_data) {
    let processed = ScheduleApiFormat.format(form_data, vm.artist);
    addRule(processed).then(function() {
      vm.status.add_new = false; // Close
    });
  };

  /**
   * @name submitException
   * @description Function to add an exception type rule to an artists hours.
   * @param {object} data The rule to send to the endpoint.
   */
  function submitException(data) {
    let processed =
    ExceptionApiFormat.format(data, vm.status, vm.day, vm.artist);
    addRule(processed).then(function() {
      vm.status.add_exception = false; // Close
    });
  }

  /**
   * @name addRule
   * @description Function to add a rule to artist hours.
   * @param {unknown} rule Unknown.
   * @return {empty} empty Returns nothing.
   */
  function addRule(rule) {
    return Schedule.submitNewRule(rule).then(function(newRule) {
      let added = ProcessSchedule.process([newRule], vm.day)[0];
      processAddition(added).then(function() {
        Schedule.refreshSchedules();
        return;
      });
    });
  }

  /**
   * @name editRule
   * @description Function to edit a rule exception.
   * @param {object} rule The rule to edit.
   * @param {unknown} submit_override unknown
   */
  vm.editRule = function(rule, submit_override) {
    let processed = ScheduleApiFormat.format(_.cloneDeep(rule), vm.artist);
    let auto_override = true;
    let diff_count = vm.calc_diff(rule);
    let _isFuture = isFuture(rule.start_date);

    let appointment_collision_data =
    Appointments.detectAppointmentCollisions(
      rule,
      vm.appointmentDayGroups,
      vm.appointments,
      vm.day
    );

    if (diff_count) {
      rule.confirm_save = true;
      auto_override = false;

      if (appointment_collision_data.applicable_appointments.length) {
        let appointment_text = appointment_collision_data.applicable_appointments.length > 1 ? 'appointments' : 'appointment';
        rule.appointment_warning = 'By modifying this rule, you may need to update ' + appointment_collision_data.applicable_appointments.length + ' current or future ' + appointment_text + '.';
      }
    } else {
      rule.confirm_save = false;
      auto_override = true;
    }

    // Simple Edits
    if ((auto_override && !submit_override) ||
    (_isFuture && !submit_override)) {
      edit(processed);
    }

    // Substantial Edits
    if (submit_override) {
      let original;
      _.each(unsorted_artist_hours, function(artist_hours) {
        if (artist_hours.id === rule.id) {
          original = _.cloneDeep(artist_hours);
        }
      });
      original = ScheduleApiFormat.format(original, vm.artist);
      // Set the Current Rule to Expire
      Schedule.removeRule(original, vm.day).then(function(removedRule) {
        let removed = ProcessSchedule.process([removedRule], vm.day)[0];
        // Process
        process_removal(removed);
        // New Start Time
        processed.start_date = moment();
        Schedule.submitNewRule(processed).then(function(newRule) {
          let added = ProcessSchedule.process([newRule], vm.day)[0];
          // Process
          processAddition(added);
        });
      });
    }
  };

  /**
   * @name editException
   * @description Editing an Exception
   * @param {object} rule The exception rule to edit.
   */
  function editException(rule) {
    let processedRule =
    ExceptionApiFormat.format(rule, vm.status, vm.day, vm.artist);
    edit(processedRule);
  }

  /**
   * @name edit
   * @description Function to edit an artist hours rule.
   * @param {object} rule The rule to edit.
   */
  function edit(rule) {
    Schedule.editRule(rule).then(function(editedRule) {
      let updated = ProcessSchedule.process([editedRule], vm.day)[0];
      processUpdated(updated);
      Schedule.refreshSchedules();
    });
  }

  /**
   * @name removeRule
   * @description Remove a Schedule Rule
   * @param {type} rule Description
   */
  function removeRule(rule) {
    let processedRule = ScheduleApiFormat.format(rule, vm.artist);
    remove(processedRule);
  }

  /**
   * @name removeException
   * @description Function to remove an exception rule from artist hours.
   * @param {object} data The rule to remove.
   */
  function removeException(data) {
    let processed =
    ExceptionApiFormat.format(data, vm.status, vm.day, vm.artist);
    remove(processed);
  }

  /**
   * @name removeRule
   * @description Function to remove a rule from artist hours.
   * @param {object} rule The rule to remove.
   */
  function remove(rule) {
    Schedule.removeRule(rule, vm.day).then(function(removedRule) {
      let removed = ProcessSchedule.process([removedRule], vm.day)[0];
      process_removal(removed);
      Schedule.refreshSchedules();
    });
  }

  /**
   * @name isFuture
   * @description Determine if the Date is Today going Forward
   * @param {type} date Description
   * @return {type} Description
   */
  function isFuture(date) {
    return moment(date).unix() >= moment().startOf('day').unix();
  }

  // Check Appointment Collisions
  vm.check_appointment_collisions = function(form_data) {
    form_data.warnings = {};

    // Re Create the Selected Day for the Form
    if (!form_data.selected_days) {
      form_data.selected_days = [{id: moment(vm.day).day(), name: moment(vm.day).format('dddd')}];
    }
    let appointment_collision_data = Appointments.detectAppointmentCollisions(form_data, vm.appointmentDayGroups, vm.appointments, vm.day);

    if (appointment_collision_data.applicable_appointments.length) {
      let applicableText = appointment_collision_data.applicable_appointments.length > 1 ? 'appointments' : 'appointment';
      form_data.appointment_warning = 'By modifying this rule, you may need to update ' + appointment_collision_data.applicable_appointments.length + ' current or future ' + applicableText + '.';
    }

    // Used to show Daily Appointment Conflicts
    if (appointment_collision_data.daily_appointments.length) {
      let dailyText = appointment_collision_data.daily_appointments.length > 1 ? 'appointments' : 'appointment';
      form_data.daily_appointments_warning = 'By modifying this rule, you may need to update the ' + appointment_collision_data.daily_appointments.length + ' ' + dailyText + ' on this day’s schedule.';
    }
  };

  /**
   * @name processAddition
   * @description Process addition
   * @param {type} added Description
   * @return {type} Description
   */
  function processAddition(added) {
    return ShopHours.get(Session.activeState.association.shop.id)
    .then(function(hours) {
      let shopHours = ScheduleUtilFactory.getShopTimes(hours.all, vm.day);
      let startOfDay = shopHours.earliest.start;
      let endOfDay = shopHours.latest.end;

      // Parse the Data
      Schedule.parseSchedules([added]);

      let selected_rule = findSelectedDay([added], startOfDay, endOfDay);

      // Push it to the Data Array
      unsorted_artist_hours.push(_.cloneDeep(added));

      if (selected_rule.length) {
        // Push it to the Data Array
        unsorted_selected_hours.push(_.cloneDeep(added));
      }

      vm.new_schedule = {temp: _.cloneDeep(temp)};
      delete vm.new_schedule.temp.raw_end_date;
      vm.status.add_new = false;

      copySortHours();
      return;
    });
  }

  /**
   * @name processUpdated
   * @description Process updated data
   * @param {type} updated Description
   */
  function processUpdated(updated) {
    Schedule.parseSchedules([updated]);

    // Find Existing and Replace.
    for (let i = 0; i < unsorted_artist_hours.length; i++) {
      if (unsorted_artist_hours[i].id === updated.id) {
        unsorted_artist_hours[i] = _.cloneDeep(updated);
      }
    }

    // Find Existing and Replace.
    for (let j = 0; j < unsorted_selected_hours.length; j++) {
      if (unsorted_selected_hours[j].id === updated.id) {
        unsorted_selected_hours[j] = _.cloneDeep(updated);
      }
    }
    copySortHours();
  }

  /**
   * @name process_removal
   * @description Process data removal
   * @param {type} removed Description
   */
  function process_removal(removed) {
    // Find Existing and Remove.
    for (let i = 0; i < unsorted_artist_hours.length; i++) {
      if (unsorted_artist_hours[i].id === removed.id) {
        unsorted_artist_hours.splice(i, 1);
      }
    }

    // Find Existing and Remove.
    for (let z = 0; z < unsorted_selected_hours.length; z++) {
      if (unsorted_selected_hours[z].id === removed.id) {
        unsorted_selected_hours.splice(z, 1);
      }
    }
    copySortHours();
  }

  // Determine the difference Between Original and New Form Data
  vm.calc_diff = function(form_data) {
    let processed = ScheduleApiFormat.format(_.cloneDeep(form_data), vm.artist);
    let _isFuture = isFuture(form_data.start_date);
    let diff_count = 0;
    let original;

    // Find Original
    _.each(unsorted_artist_hours, function(artist_hours) {
      if (artist_hours.id === form_data.id) {
        original = artist_hours;
      }
    });

    // Current Rules Only
    if (!_isFuture) {
      // Weekly Frequency
      if (original.weekly_frequency !== processed.interval) {
        diff_count++;
      }

      // Start Time
      if (moment(original.start_time).format('HH:mm:ss') !==
      processed.start_time) {
        diff_count++;
      }

      // End Time
      if (moment(original.end_time).format('HH:mm:ss') !== processed.end_time) {
        diff_count++;
      }

      // Selected Days
      if (!_.isEqual(original.selected_days, processed.selected_days)) {
        diff_count++;
      }
    }

    // Hide the Confirm Prompt
    form_data.confirm_save = diff_count ? null : false;
    return diff_count;
  };

  /**
   * @name get_schedule
   * @description Get the Schedule for an Artist
=   */
  function get_schedule() {
    vm.loading = true;

    ShopHours.get(Session.activeState.association.shop.id)
    .then(function(hours) {
      let shopHours = ScheduleUtilFactory.getShopTimes(hours.all, vm.day);
      let startOfDay = shopHours.earliest.start;
      let endOfDay = shopHours.latest.end;

      Schedule.refreshSchedules().then(function() {
        vm.loading = false;

        // Get the Artist Schedule
        unsorted_artist_hours = ProcessSchedule.process(Schedule.getArtistSchedule(vm.artist.id), vm.day);

        // Get 'this' day's Schedule
        unsorted_selected_hours = findSelectedDay(unsorted_artist_hours, startOfDay, endOfDay);
        copySortHours();
      });
    });

    // Generate the Appointment Rules
    // TODO Check the callstack here to ensure the data is ready for whatever this function is trying to accomplish.
    // Appointments.organizeAppointments(vm.appointments, vm.artist, vm.day);
  }

  // Determine if the schedule data contains an 'off' exeception.
  vm.is_off = function() {
    for (let i = 0; i < unsorted_selected_hours.length; i++) {
      if (unsorted_selected_hours[i].is_off) {
        return true;
      }
    }
    return false;
  };

  /**
   * @name findSelectedDay
   * @description Return only the hours for the selected day
   * @param {type} artistHours Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function findSelectedDay(artistHours, start, end) {
    return ProcessSchedule.process(ScheduleUtilFactory.getApplicableRules(start, end, artistHours), start);
  }

  /**
   * @name copySortHours
   * @description description
   */
  function copySortHours() {
    vm.artist_schedule = _.cloneDeep(Schedule.sort_hour_types(unsorted_artist_hours, today));
    vm.selected_hours = _.cloneDeep(Schedule.sort_hour_types(unsorted_selected_hours, vm.day));
  }

  // Cancel and Close the Modal.
  vm.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}

angular
  .module('inkfinder')
  .controller('ScheduleUpdateController', ScheduleUpdateController);



// WEBPACK FOOTER //
// ./components/schedule/update/schedule-update-controller.js